import React from 'react';
import './DishCard.css';

function DishCard({ name, description, image }) {
    return (
            <div className="dish-card">
                <img src={image} alt={name} className="dish-image" />
                <h2 className="dish-name">{name}</h2>
                <p className="dish-description">{description}</p>
            </div>
    );
}

export default DishCard;